import { PText, PTextFieldWrapper, PIcon, PFlex, PFlexItem, PButton } from '@porsche-design-system/components-react'
import clsx from 'clsx'
import React from 'react'

import { ReportingContext } from '../../../utils/Context/ReportingContext'
import useOnClickOutside from '../../../utils/ReusableHooks/useOnClickOutside'

import { PortalContext } from '../../../utils/PortalContext'

import styles from './collapsiblefilter.module.css'

interface AppList {
  appName: string
  appNumber: number
}

type Props = {
  data: AppList[]
  placeholderText: string
}

const CollapsibleFilterApplication: React.FC<Props> = ({ data, placeholderText }) => {
  const {
    setChosenApplication,
    chosenApplication,
    setChosenDepartment,
    setFilter,
    filter,
    setOpenSubApps,
    applicationButton,
    setApplicationButton,
    setAppId,
    openFilterMenu,
    setOpenFilterMenu,
    openApplicationMenu,
    setOpenApplicationMenu,
    openDepartmentMenu,
    setOpenDepartmentMenu,
    setCalendarIsOpen,
    setShowSingleRatings,
    setContentHeader,
    setDepartmentButton,
    setResetParams,
    setShowDepartmentList
  } = React.useContext(ReportingContext)

  const ref = React.useRef(null)

  const handleClickOutside = () => {
    setOpenApplicationMenu(false)
  }

  const handleClickInside = () => {
    setOpenApplicationMenu(true)
  }

  useOnClickOutside(ref, handleClickOutside)

  const { loading } = React.useContext(PortalContext)

  const [filteredData, setFilteredData] = React.useState(data)
  const [searchTerm, setSearchTerm] = React.useState('')
  const [openMenu, setOpenMenu] = React.useState(false)

  const handleChange = (e: any) => {
    setSearchTerm(e.target.value)
  }

  const clickHandler = (element: any) => {
    setChosenApplication(element.appName === 'Alle Applikationen' ? '' : element.appName)
    setContentHeader(element.appName)
    setChosenDepartment('')
    setFilter({ ...filter, app: element.appName === 'Alle Applikationen' ? [] : [element.appNumber], department: [] })
    setAppId(element.appNumber)
    setOpenSubApps(element.appName !== 'Alle Applikationen' && true)
    setApplicationButton(element.appName)
    setDepartmentButton('Alle Abteilungen')
    setOpenMenu(false)
    setOpenFilterMenu(false)
    setShowSingleRatings(true)
    setShowDepartmentList(false)
    setResetParams(true)
    if (element.appName === 'Alle Applikationen') {
      setShowSingleRatings(false)
      setShowDepartmentList(true)
    }
  }

  const handleKeyDown = (e: any) => {
    // it triggers by pressing the enter key

    if (e.key === 'Enter') {
      setSearchTerm(e.target.value)

      // @ts-ignore: filter function
      setFilteredData(filteredData.filter((data) => data.appName.toLowerCase().includes(searchTerm.toLowerCase())))

      if (filteredData!.length !== 0 && filteredData!.length < 2) {
        // @ts-ignore: filter function
        setChosenApplication(filteredData[0].appName)
        setChosenDepartment('')
        setResetParams(true)
        // @ts-ignore: filter function
        setContentHeader(filteredData![0].appName)
        setFilter({
          ...filter,
          // @ts-ignore: filter function
          app: filteredData[0].appName === 'Alle Applikationen' ? [] : [filteredData[0].appNumber],
          department: []
        })
        // @ts-ignore: filter function
        setAppId(filteredData[0].appNumber)
        // @ts-ignore: filter function
        setOpenSubApps(filteredData[0].appName !== 'Alle Applikationen' && true)
        // @ts-ignore: filter function
        setApplicationButton(filteredData[0].appName)
        setOpenMenu(false)
        setOpenFilterMenu(false)
      }
    }
  }

  let results: AppList = [] as any

  React.useEffect(() => {
    if (!searchTerm) {
      return setFilteredData(data)
    }

    // @ts-ignore: filter function
    results = filteredData.filter((data) => data.appName.toLowerCase().includes(searchTerm.toLowerCase()))

    // @ts-ignore
    if (filteredData !== results && results.length > 0) {
      // @ts-ignore
      setFilteredData(results)
    }
  }, [searchTerm])

  const buttonClick = () => {
    setOpenMenu(!openMenu)
    setOpenApplicationMenu(!openApplicationMenu)
    setOpenDepartmentMenu(false)
    setCalendarIsOpen(false)
    setOpenFilterMenu(true)
  }

  React.useEffect(() => {
    if (openApplicationMenu) {
      setOpenDepartmentMenu(false)
    }
  }, [openApplicationMenu])

  return (
    <div ref={ref} onClick={handleClickInside}>
      <PButton variant='tertiary' className={styles.buttonHeader} onClick={buttonClick} disabled={loading}>
        {applicationButton}
      </PButton>

      {openApplicationMenu &&
        openFilterMenu &&
        /* openMenu && */
        !openDepartmentMenu && (
          <div className={styles.collapsible}>
            <PTextFieldWrapper>
              <input
                type='search'
                placeholder={placeholderText}
                name='search'
                onChange={handleChange}
                onClick={() => setFilteredData(data)}
                onKeyDown={handleKeyDown}
              />
            </PTextFieldWrapper>
            <PFlex direction='column' className={styles.list}>
              {filteredData.length > 0 &&
                filteredData.map((element: any, id: number) => (
                  <PFlexItem
                    className={clsx(styles.listItem, {
                      [styles.chosen]: chosenApplication === element.appName
                    })}
                    key={id}
                  >
                    <PText onClick={() => clickHandler(element)}>
                      <PIcon
                        name='arrow-head-right'
                        aria-label='Arrow Head Right icon'
                        color='brand'
                        className={clsx(styles.listSpace)}
                      />
                      {element.appName}
                    </PText>
                  </PFlexItem>
                ))}
            </PFlex>
          </div>
        )}
    </div>
  )
}

export default CollapsibleFilterApplication
